import {SET_TAXES_FLAG} from "../types/flag";
import {isFeatureFlagEnable} from "../api/unleash";
import {UnleashToggles} from "../types/unleashToggles";

export const setTaxesFlag = (flagValue) => {
  return {
    type: SET_TAXES_FLAG,
    payload: flagValue
  }
}

export const getUnleashFlag = (unleashFlag) => async (dispatch) => {
  const flagEnabled = await isFeatureFlagEnable(unleashFlag).catch(_ => false)
  const reducer = pickReducer(unleashFlag);
  if (reducer) dispatch(reducer(flagEnabled));
  return flagEnabled;
}

const pickReducer = (unleashFlag) => {
  switch (unleashFlag) {
    case UnleashToggles.CAN_USE_TAXES_MFE:
      return setTaxesFlag
    default:
      return undefined
  }
}


// WEBPACK FOOTER //
// ./src/actions/flag.js